export default "__VITE_ASSET__B9CH91rx__"